import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withModifiers as _withModifiers, createElementVNode as _createElementVNode, withDirectives as _withDirectives, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-13b5916b"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "flex flex-col gap-5 max-w-screen-md modal-content-body sm:shrink"
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ModalComponent',
  props: {
  modalActive: {
    type: Boolean,
    default: false
  }
},
  emits: ['close'],
  setup(__props) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, { name: "modal-outer" }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", {
          onMousedown: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('close')), ["self"])),
          class: "modal-background"
        }, [
          _createVNode(_Transition, { name: "modal-inner" }, {
            default: _withCtx(() => [
              (__props.modalActive)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _renderSlot(_ctx.$slots, "title"),
                    _renderSlot(_ctx.$slots, "subtitle"),
                    _renderSlot(_ctx.$slots, "body"),
                    _renderSlot(_ctx.$slots, "navigation")
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 3
          })
        ], 544), [
          [_vShow, __props.modalActive]
        ])
      ]),
      _: 3
    })
  ]))
}
}

})